import { render, staticRenderFns } from "./Toggle-details-button.vue?vue&type=template&id=6a173e71"
import script from "./Toggle-details-button.vue?vue&type=script&lang=js"
export * from "./Toggle-details-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports